import { FilePreviewDialog } from "@/components/ui/file-preview";

interface PdfViewerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  pdfUrl: string;
}

export const PdfViewerDialog = ({
  open,
  onOpenChange,
  pdfUrl,
}: PdfViewerDialogProps) => {
  return (
    <FilePreviewDialog
      open={open}
      onOpenChange={onOpenChange}
      fileUrl={pdfUrl}
      fileName="treatment-document.pdf"
      title="Treatment Document"
    />
  );
};
